import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import MapOfEurope from './MapOfEurope';

import t from '../application/translate';

const MapDiv = styled.div`
  max-width: 1360px;
`;

const MapRight = styled.div`
  margin-right: 200px;
`;

const Legend = styled.div.attrs({
  className: 'flex justify-around leading-loose',
})`
  padding: 0 190px 70px 260px;
  font-size: 14px;
`;

const Title = styled.div.attrs({
  className: 'leading-tight',
})`
  font-weight: 600;
  padding-top: 12px;
  padding-bottom: 26px;
  max-width: 180px;
`;

const BrownDiv = styled.div`
  width: 60px;
  height: 10px;
  background-color: #d9c983;
  padding-top: 12px;
`;

const YellowDiv = styled.div`
  width: 60px;
  height: 10px;
  background-color: #fbea9f;
`;

const GreyDiv = styled.div`
  width: 60px;
  height: 10px;
  background-color: #c2c1c0;
`;

function fillColor(country, isHover) {
  if(country.isSchengen && country.isEU) {
    return isHover ? '#f8d347' : '#fbea9f';
  }
  else if(country.isSchengen && !country.isEU) {
    return isHover ? '#f8d347' : '#d9c983';
  }
  else if(!country.isSchengen && country.isEU) {
    return isHover ? '#ffd200' : '#c2c1c0';
  }
  else {
    return '#919091';
  }
}

function SchengenZoneMap(props) {
  const { countries, isFetching } = props.store.state;
  const { language } = props;

  if(isFetching) {
    return null;
  }

  function DivideCoutries() {
    let schengenAndEU = [];
    for(let i = 0; i < countries.length; i++) {
      if(countries[i].isSchengen && countries[i].isEU) {
        schengenAndEU.push(
          <div key={i.toString()} value={countries.threeLetterCode}>
            {countries[i].name[language]}
          </div>,
        );
      }
    }
    return schengenAndEU;
  }

  const firstColumn = DivideCoutries().slice(0, 8);
  const secondColumn = DivideCoutries().slice(8, 16);
  const thirdColumn = DivideCoutries().slice(16, 22);

  return (
    <React.Fragment>
      <MapDiv>
        <MapRight>
          <MapOfEurope
            width={1200}
            fillColor={fillColor}
            store={props.store}
            language={language}
          />
        </MapRight>
        <Legend>
          <div>
            <BrownDiv />
            <Title>{t('schengenLegend/schengenAndNotEU')}</Title>
            {countries.map((country) => {
              if(country.isSchengen && !country.isEU) {
                return (
                  <div
                    key={country.threeLetterCode}
                    value={country.threeLetterCode}
                  >
                    {country.name[language]}
                  </div>
                );
              }
              else {
                return null;
              }
            })}
          </div>
          <div>
            <YellowDiv />
            <Title>{t('schengenLegend/schengenAndEU')}</Title>
            <div className="flex justify-between">
              <div>{firstColumn}</div>
              <div className="px-9">{secondColumn}</div>
              <div>{thirdColumn}</div>
            </div>
          </div>
          <div className="leg3">
            <GreyDiv />
            <Title>{t('schengenLegend/notSchengenAndEU')}</Title>
            {countries.map((country) => {
              if(!country.isSchengen && country.isEU) {
                return (
                  <div
                    key={country.threeLetterCode}
                    value={country.threeLetterCode}
                  >
                    {country.name[language]}
                  </div>
                );
              }
              else {
                return null;
              }
            })}
          </div>
        </Legend>
      </MapDiv>
    </React.Fragment>
  );
}

MapOfEurope.propTypes = {
  countries: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.shape({
        cz: PropTypes.string,
        en: PropTypes.string,
        ru: PropTypes.string,
      }),
      threeLetterCode: PropTypes.string,
    }),
  ),
};

export default SchengenZoneMap;



// WEBPACK FOOTER //
// ./src/maps/SchengenZoneMap.js